export default __webpack_public_path__ + "assets/i18n/translations/de.json";